import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ConfirmationPanel.css';

class ConfirmationPanel extends Component {
  static propTypes = {
    className: PropTypes.string,
    image: PropTypes.string.isRequired,
    firstLine: PropTypes.string.isRequired,
    lines: PropTypes.arrayOf(PropTypes.string).isRequired,
    buttons: PropTypes.arrayOf(PropTypes.object).isRequired,
  };

  render() {
    return (
      <div className="confirmation-panel">
        <div
          className={
            this.props.className !== undefined ? this.props.className : null
          }
        >
          <img src={this.props.image} alt="confirmation-panel-img" />
          <div className="first-line-container">{this.props.firstLine}</div>
          <div className="lines-container">
            {this.props.lines.map((element, index) => {
              return <div key={index}>{element}</div>;
            })}
          </div>
          <div className="buttons-container">
            {this.props.buttons.map((element, index) => {
              return <span key={index}>{element}</span>;
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default ConfirmationPanel;



// WEBPACK FOOTER //
// ./src/components/shared/confirmation/ConfirmationPanel.js